export default "__VITE_ASSET__5676947f__"